export enum ColumnFilterType {
  Values = 'Values',
  Comparison = 'Comparison',
  Range = 'Range',
}
